export const numberMask = (value: string) => value.replace(/\D/g, '')

export const zipCodeMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1')

export const socialDocumentNumberMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')

export const creditCardMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d{1,3})/, '$1 $2')
    .replace(/(\d{4} \d{6} \d{5})\d+?$/, '$1')

export function integerMask(input: string) {
  return input.replace(/[^0-9.]/g, '').replace(/^0+(?!$)/g, '')
}

export function currencyMask(input: string) {
  const clean = input.replace(/[^0-9,]/g, '')
  if (!clean) return ''
  const parts = clean.split(',')
  let intPart = parts[0].replace(/^0+(?=\d)/, '')
  if (intPart === '') intPart = '0'
  
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  
  let decPart = parts.length > 1 ? parts.slice(1).join('').slice(0, 2) : ''
  decPart = decPart.padEnd(2, '0')
  return `R$ ${intPart},${decPart}`
}

export function floatMask(input: string) {
  return input
    .replace(/\D/g, '')
    .replace(/^0+/, '')
    .padStart(3, '0')
    .replace(/(\d+)(\d{2})$/, '$1,$2')
}

export const phoneMask = (value = '') =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')

export const documentNumberMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')

export const dateMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')

export const monthYearMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\/\d{2})\d+?$/, '$1')

export const cvvMask = (value: string) =>
  value.replace(/\D/g, '').replace(/(\d{4})\d+?$/, '$1')
